import { CapTableOrdering, Column, DetailsSortVariant, ViewBy } from '../../types/snapshot.types';
import { localStorageUtil } from '../../utils/local-storage.util';

export const capTableStore = localStorageUtil<
  {
    customCapTableDate: Date | null;
    /**
     * The Ordering tab is one configuration shared by both view modes, so it sits beside the
     * per-mode column settings rather than inside them.
     */
    ordering: CapTableOrdering | null;
  } & Record<
    DetailsSortVariant,
    {
      columns: Column[];
      viewBy: Record<ViewBy, boolean>;
    } | null
  >
>('capTableStore');
